/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'cargoes-address-fields',
  templateUrl: './address-fields.component.html',
  styleUrls: ['./address-fields.component.less']
})
export class AddressFieldsComponent implements OnInit {

  @Input() public addressForm: FormGroup 
  @Input() public listNationality: any = [];
  @Input() public listStates: any = [];


  constructor(private fb: FormBuilder) {
  this.addressForm=this.fb.group({})
  }

  ngOnInit(): void {
  }

}
